import LoanAmount from './LoanAmount';

export default LoanAmount;
